import React, { useState } from 'react';
import '../styles/Trabajos.css';
import '../styles/index.css';
import '../styles/main.css';

const Filtros = ({ onFiltrar, categoriasDisponibles, onSearch }) => {
  const [categoria, setCategoria] = useState('');
  const [experiencia, setExperiencia] = useState(0);
  const [modalidad, setModalidad] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onFiltrar({ categoria, experiencia, modalidad });
  };

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    onSearch(term);
  };

  return (
    <form className="container mb-4" onSubmit={handleSubmit} id="filtros-form" method="GET">
      <div className="row g-3">
        {/* Filtro por categoría */}
        <div className="col-md-4">
          <label className="form-label" htmlFor="categoria">Categoría</label>
          <select
            id="categoria"
            name="categoria"
            className="form-select form-control-lg"
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
          >
            <option value="">Todas las categorías</option>
            {categoriasDisponibles.map((cat) => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>

        {/* Filtro por experiencia */}
        <div className="col-md-4">
          <label className="form-label" htmlFor="experiencia">Experiencia mínima</label>
          <input
            type="range"
            id="experiencia"
            name="experiencia"
            className="form-range"
            min="0"
            max="10"
            step="1"
            value={experiencia}
            onChange={(e) => setExperiencia(e.target.value)}
          />
          <output htmlFor="experiencia">{experiencia} años</output>
        </div>

        {/* Filtro por modalidad */}
        <div className="col-md-4">
        <label className="form-label">Modalidad</label>
        <div className="form-check">
            <input
            type="checkbox"
            className="form-check-input"
            id="presencial"
            name="modalidad"
            value="presencial"
            checked={modalidad === 'presencial'}
            onChange={() =>
                setModalidad(modalidad === 'presencial' ? '' : 'presencial')
            }
            />
            <label className="form-check-label" htmlFor="presencial">Presencial</label>
        </div>
        <div className="form-check">
            <input
            type="checkbox"
            className="form-check-input"
            id="remoto"
            name="modalidad"
            value="virtual"
            checked={modalidad === 'remoto'}
            onChange={() =>
                setModalidad(modalidad === 'remoto' ? '' : 'remoto')
            }
            />
            <label className="form-check-label" htmlFor="remoto">Virtual</label>
        </div>
        </div>

        <div className="col-12">
            <button className="btn btn-aplicar" type="submit">Aplicar Filtros</button>
            <a className="btn btn-secondary ms-2" href="/trabajos">Limpiar</a>
        </div>
      </div>
    </form>
  );
};

export default Filtros;
